module.exports = new __parcel__URL__("gold_pack_icon.15469798.png").toString();